module.exports = __webpack_public_path__ + "img/Salesforce.5b6a6678.svg";